<template>
  <label
    class="switch"
    :class="{
      'switch--disabled': disabled,
      'switch--error': error,
      'switch--checked': checked,
      'switch--reverse': reverse,
      'switch--full-width': fullWidth,
    }"
  >
    <input
      type="checkbox"
      :checked="checked"
      :disabled="disabled"
      @change="$emit('change', $event.target.checked)"
    />
    <span class="switch__slider"></span>
    <slot />
  </label>
</template>

<script>
export default {
  name: "SwitchComponent",
  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    error: Boolean,
    checked: Boolean,
    disabled: Boolean,
    reverse: Boolean,
    fullWidth: Boolean,
  },
};
</script>

<style lang="stylus">
.switch {
  display inline-flex
  gap 10px
  position relative
  cursor pointer
  align-items center
  user-select none
  transition var(--transition)

  input {
    absolute left top
    visibility hidden
  }

	&--reverse {
		flex-direction row-reverse
	}

	&--full-width {
		width 100%
		justify-content space-between
	}

  &--error {
    & .switch__slider {
      border-color var(--red)
      background var(--red)
    }
  }

  &--disabled {
    cursor not-allowed
    opacity 0.6

    & .switch__slider {
      background var(--gray)
    }
  }

  &--checked {
    & .switch__slider {
      background var(--main-color)

      &:before {
        transform translateX(20px)
      }
    }
  }

  &__slider {
    width 44px
    height 24px
    background var(--gray-2)
    border-radius 24px
    position relative
    transition var(--transition)
    flex-shrink 0

    &:before {
      content ""
      position absolute
      height 20px
      width 20px
      left 2px
      top 2px
      background var(--white)
      border-radius 50%
      transition var(--transition)
      box-shadow 0 2px 4px rgba(0, 0, 0, 0.2)
    }
  }

  &:hover:not(.switch--disabled) {
    & .switch__slider {
      opacity 0.85
    }
  }
}
</style>
